import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, TransitionGroup as _TransitionGroup, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b9845a04")

_pushScopeId("data-v-b9845a04")
const _hoisted_1 = { class: "d-good-road-panel-root" }
const _hoisted_2 = { class: "panel-wrap" }
const _hoisted_3 = { class: "panel" }
const _hoisted_4 = { class: "tab" }
const _hoisted_5 = {
  key: 0,
  class: "tab-count"
}
const _hoisted_6 = {
  key: 0,
  class: "tab-count"
}
const _hoisted_7 = { class: "list-wrap" }
const _hoisted_8 = { class: "list-scroll" }
const _hoisted_9 = {
  key: "good-road-empty",
  class: "empty"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "icon icon-close" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_d_good_road_item = _resolveComponent("d-good-road-item")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", {
            class: ["tab-item", { active: _ctx.selectedIndex === 'G002' }],
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeIndex('G002')))
          }, [
            _createTextVNode(_toDisplayString(_ctx.iN('common.baccarat')) + " ", 1),
            (_ctx.baccaratGoodRoadCount > 0)
              ? (_openBlock(), _createBlock("span", _hoisted_5, _toDisplayString(_ctx.baccaratGoodRoadCount), 1))
              : _createCommentVNode("", true)
          ], 2),
          _createVNode("div", {
            class: ["tab-item", { active: _ctx.selectedIndex === 'G003' }],
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeIndex('G003')))
          }, [
            _createTextVNode(_toDisplayString(_ctx.iN('common.dragontiger')) + " ", 1),
            (_ctx.dragonTigerGoodRoadCount > 0)
              ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.dragonTigerGoodRoadCount), 1))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("div", _hoisted_8, [
            _createVNode(_TransitionGroup, {
              name: "good-road-list",
              tag: "div",
              class: "list"
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listData, (entry) => {
                  return (_openBlock(), _createBlock("div", {
                    key: entry.table.id,
                    class: "list-item-wrap"
                  }, [
                    _createVNode(_component_d_good_road_item, {
                      class: "list-item",
                      entry: entry,
                      chipValue: _ctx.chipValue,
                      onOnBetSuccess: _ctx.onItemBetSuccess
                    }, null, 8, ["entry", "chipValue", "onOnBetSuccess"])
                  ]))
                }), 128)),
                (!_ctx.listData.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_9, " 暂无桌台 "))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode("button", {
        class: "close-btn",
        type: "button",
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideMe && _ctx.hideMe(...args)))
      }, [
        _hoisted_10
      ])
    ])
  ]))
})